import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../types'
import { TabBoxItemData } from './tab-box-item/tab-box-item.component.converter'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TabBoxConverter extends CmsConverterService<TabBoxData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      items: formData.st_items ?? defaultFSCatalog
    }
  }
}

export const TAB_BOX_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TabBoxData>>('TabBoxConverter')

export interface TabBoxData extends ConvertedComponentData {
  items: FsCatalog<TabBoxItemData>;
}
